<template>
	<teleport to="body">
		<div
			class="modal"
			:class="{ show: show && !showLeftoversModal }"
			tabindex="-1"
			v-if="meal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{ getName(meal) }}</h5>
						<button
							@click="closeModal"
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="cover-container shadow">
							<!-- Full Screen Button -->
							<button
								class="fullscreen-button"
								@click="isFullScreen = !isFullScreen">
								<i class="bi bi-fullscreen"></i>
								<!-- Using Bootstrap Icons, adjust as needed -->
							</button>
							<div class="w-100 h-100">
								<ImageLoader
									:src="getImageSource(meal.img)"
									class="cover-image" />
							</div>
							<div class="cover-overlay">
								<div class="badges" v-if="meal.cook_type && meal.meal_type">
									<span
										class="badge me-2"
										:class="[getCookTypeColor(meal.cook_type)]"
										>{{ meal.cook_type }}</span
									><span
										class="badge"
										:class="[getMealTypeColor(meal.meal_type)]"
										>{{ meal.meal_type }}</span
									>
								</div>
								<div v-if="meal.restaurant_name" class="location">
									<div class="d-flex align-items-center">
										<i class="bi bi-geo-alt-fill me-2"></i>
										<span>{{ meal.restaurant_name }}</span>
									</div>
								</div>
								<div class="w-100">
									<p v-text="truncatedImageDescription"></p>
									<div
										class="text-white text-center w-100 showMore"
										v-if="isTruncated"
										@click="showMoreImgDesc">
										Show More
									</div>
								</div>
								<!-- <p v-else>{{ getDrinkDescription(meal) }}</p> -->
								<allergy :meal="meal" />
								<div class="rating-container">
									<a
										href="#"
										title="Health Score of Item (Click to see more)"
										v-if="meal.rating">
										<rating-gauge
											class="rating-gauge"
											width="80"
											:rating="meal.rating"
											@click="toggleInsights" />
									</a>
								</div>
							</div>
						</div>

						<div>
							<div v-if="hasToken() && isOnline">
								<div
									class="text-center my-2"
									v-if="
										!userStore.isViewingUser() &&
										!showPrompt &&
										!showQuickAddModal &&
										!showtoggleCookingInstructions &&
										!showInsights &&
										!showTag
									">
									<button
										class="btn btn-sm btn-primary mx-2"
										@click="showRePrompt"
										title="Edit Item">
										<i class="bi bi-pencil"></i>
									</button>
									<!-- Tag Button -->
									<button
										class="btn btn-sm btn-info mx-2"
										@click="handleTagClick"
										title="Edit Tags on Item">
										<i class="bi bi-tag"></i>
									</button>
									<!-- Duplicate Button -->
									<button
										class="btn btn-sm btn-secondary mx-2"
										@click="showQuickAdd"
										title="Duplicate Item">
										<i class="bi bi-files"></i>
									</button>
									<!-- Leftovers -->
									<button
										class="btn btn-sm btn-warning mx-2"
										@click="openLeftovers"
										title="Log Leftovers on Item">
										<i class="bi bi-archive"></i>
									</button>
									<!-- Cooking instructions-->
									<button
										class="btn btn-sm btn-success mx-2"
										@click="toggleCookingInstructions"
										title="Cooking Instructions for Item">
										<i class="bi bi-cup-hot"></i>
									</button>
									<!--<button
										class="btn btn-sm btn-dark mx-2"
										@click="shareToX"
										title="Post on X">
										𝕏
									</button>-->
								</div>

								<!-- Reprompt -->
								<div class="mb-3" v-if="showPrompt">
									<h5>Edit</h5>
									<form @submit.prevent="sendPrompt">
										<div class="mb-3">
											<label class="form-label">Adjust info</label>
											<textarea
												class="w-100 form-control"
												rows="3"
												v-model="newPrompt"></textarea>
											<!-- Voice Recording -->
											<!-- <div class="mt-3" v-if="showRec">
												<div v-if="showRecording">
													<p>{{ recordingStatus }}</p>
													<button
														@click="cancelRecording"
														type="button"
														class="btn btn-danger"
														:disabled="sendingAudio">
														Cancel
													</button>
													<button
														@click="stopRecording"
														type="button"
														class="btn btn-primary"
														:disabled="sendingAudio">
														Stop
													</button>
												</div>
												<div v-else>
													<button
														@click="startRecording"
														type="button"
														class="btn btn-primary">
														<i class="bi bi-mic"></i>
													</button>
												</div>
											</div> -->
										</div>
										<!-- <button
											type="button"
											class="btn btn-lg btn-danger me-3"
											@click="cancelPrompt"
											:disabled="sendingAudio"
											>
											Cancel
										</button>
										<button
											type="submit"
											class="btn btn-lg btn-primary"
											:disabled="sendingAudio">
											Submit
										</button> -->
										<button
											type="button"
											class="btn btn-lg btn-danger me-3"
											@click="cancelPrompt">
											Cancel
										</button>
										<button type="submit" class="btn btn-lg btn-primary">
											Submit
										</button>
									</form>
								</div>

								<!--Edit Tag Section-->
								<div v-if="showTag" class="mb-3">
									<h5>Edit Attributes</h5>
									<tags
										:meal="meal"
										@cookType="(v) => (newCookType = v)"
										@mealType="(v) => (newMealType = v)"
										@restaurantName="(v) => (newRestaurantName = v)"
										@customRestaurant="handleCustomRestaurant"
										v-if="meal.cook_type && meal.meal_type" />
									<div class="my-3">
										<label for="mealDateTime" class="form-label"
											>Date and Time</label
										>
										<input
											type="datetime-local"
											class="form-control"
											id="mealDateTime"
											v-model="newDateTime" />
									</div>
									<div class="mt-4">
										<button
											type="button"
											class="btn btn-lg btn-danger me-3"
											@click="closeTagClick">
											Cancel
										</button>
										<button
											type="button"
											class="btn btn-lg btn-primary"
											@click="submitTagClick">
											Submit
										</button>
									</div>
								</div>

								<!-- Quick Add Section -->
								<div v-if="showQuickAddModal" class="mb-3">
									<h5>Quick Add</h5>
									<input
										type="datetime-local"
										v-model="quickAddDate"
										class="form-control mb-3" />
									<div>
										<button
											class="btn btn-lg btn-danger me-3"
											@click="cancelQuickAdd">
											Cancel
										</button>
										<button
											class="btn btn-lg btn-primary"
											@click="handleQuickAdd">
											Submit
										</button>
									</div>
								</div>
							</div>

							<div v-if="showtoggleCookingInstructions">
								<div v-if="cookingLoading">Fetching...</div>
								<markdown
									:source="cookingInstructions"
									v-if="cookingInstructions" />
								<div class="my-3">
									<button
										class="btn btn-lg btn-danger me-3"
										@click="toggleCookingInstructions">
										Close
									</button>
								</div>
							</div>

							<div v-if="showInsights">
								<markdown :source="displayedInsights()" />
								<div class="my-3">
									<button
										class="btn btn-lg btn-danger me-3"
										@click="toggleInsights">
										Close
									</button>
								</div>
							</div>

							<!-- Total Nutritional Information -->
							<div class="nutrition-label">
								<div class="d-flex justify-content-between align-items-center">
									<h3 class="mb-0">Total Nutritional Information</h3>
									<div
										class="form-check form-switch"
										v-if="meal.entry.before_nutritional_info">
										<input
											class="form-check-input"
											type="checkbox"
											id="showBeforeNutritionInfo"
											v-model="showBeforeNutritionInfo" />
										<label
											class="form-check-label"
											for="showBeforeNutritionInfo">
											{{ showBeforeNutritionInfo ? "Original" : "Consumed" }}
										</label>
									</div>
								</div>
								<ul>
									<li
										v-for="(value, key) in showBeforeNutritionInfo &&
										meal.entry.before_nutritional_info
											? meal.entry.before_nutritional_info
											: meal.entry.nutritional_info"
										:key="key">
										<span class="key">{{ formatNutritionKey(key) }}</span>
										<span class="value">{{ value }}</span>
									</li>
								</ul>
							</div>

							<template v-if="!meal.entry?.version">
								<div v-if="meal.type === 'food'">
									<!-- Components and Nutritional Info -->
									<h3>Components</h3>
									<div class="row row-cols-1 row-cols-md-2 g-2 mb-3">
										<div
											v-for="component in meal.entry.foods"
											:key="component.name"
											class="col">
											<div class="card h-100">
												<div class="card-header">
													<h4 class="card-title">{{ component.name }}</h4>
												</div>
												<div class="card-body">
													<!-- Quantity Description -->
													<p class="card-text">
														{{ component.image_quantity_description }}
													</p>

													<!-- Nutritional Information -->
													<!-- <div v-if="component.nutritional_info_total">
											<h5>Nutritional Information:</h5>
											<ul class="list-unstyled">
												<li
													v-for="(value, key) in component.nutritional_info_total"
													:key="key">
													<strong>{{ key }}:</strong> {{ value }}
												</li>
											</ul>
										</div> -->

													<!--Components -->
													<div v-if="component?.addons?.length">
														<h5>Components</h5>
														<li
															v-for="(value, key) in component.addons"
															:key="key">
															{{ value }}
														</li>
													</div>
												</div>
											</div>
										</div>
									</div>

									<h5 class="mt-2">Allergens</h5>
									<p>{{ getAllergens(meal.entry.allergens) }}</p>
								</div>

								<div v-else>
									<div v-if="meal.entry?.addons?.length">
										<h5>Addons</h5>
										<li v-for="(value, key) in meal.entry.addons" :key="key">
											{{ value }}
										</li>
									</div>
								</div>
							</template>
							<template v-else-if="meal.entry?.version === 2">
								<!--<h5>Components</h5>
								 <div class="row row-cols-1 row-cols-md-2 g-2 mb-3">
									<div
										v-for="(item, idx) in meal.entry.items"
										:key="item.name + idx"
										class="col">
										<div class="card h-100">
											<div
												class="card-header d-flex flex-column flex-md-row justify-content-between align-items-md-center">
												<h5 class="mb-1 mb-md-0">{{ item.name }}</h5>
												<small class="text-muted" v-if="item.quantity">{{
													item.quantity
												}}</small>
											</div>
											<div class="card-body">
												<p class="mb-2" v-if="item.description">
													{{ item.description }}
												</p>
												<div v-if="item.container_type">
													<span class="badge bg-info text-dark"
														>Container: {{ item.container_type }}</span
													>
												</div>
												<div class="mt-2">
													<h6 class="mb-1">Nutritional Info</h6>
													<ul class="list-unstyled mb-2">
														<li
															v-for="(value, key) in item.nutritional_info"
															:key="key">
															<strong
																>{{
																	key
																		.replace(/_/g, " ")
																		.replace(/\b\w/g, (l) => l.toUpperCase())
																}}:</strong
															>
															{{ value }}
														</li>
													</ul>
												</div>
												<div v-if="item.allergens && item.allergens.length">
													<span
														class="badge bg-danger text-light me-1"
														v-for="(allergen, aidx) in item.allergens"
														:key="aidx">
														{{ allergen }}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div> -->
								<div class="accordion orange-accordion" id="itemAccordion">
									<div
										class="d-flex justify-content-between align-items-center gap-2 mb-2">
										<h5 class="mb-0">Components</h5>
										<button
											v-if="canEditComponents && selectedComponentIndexes.length"
											type="button"
											class="btn btn-sm btn-danger"
											@click="removeSelectedComponents"
											title="Remove selected components">
											<i class="bi bi-trash"></i>
											<span class="ms-1">{{ selectedComponentIndexes.length }}</span>
										</button>
									</div>
									<div
										class="accordion-item"
										v-for="(item, idx) in meal.entry.items"
										:key="item.name + idx">
										<h2
											class="accordion-header component-accordion-header"
											:id="'heading' + idx">
											<div
												v-if="canEditComponents"
												class="form-check component-select">
												<input
													class="form-check-input"
													type="checkbox"
													:id="'component-select-' + idx"
													:value="idx"
													v-model="selectedComponentIndexes"
													@click.stop />
												<label
													class="form-check-label visually-hidden"
													:for="'component-select-' + idx">
													Select {{ item.name }}
												</label>
											</div>
											<button
												class="accordion-button collapsed orange-accordion-header"
												type="button"
												data-bs-toggle="collapse"
												:data-bs-target="'#collapse' + idx"
												aria-expanded="false"
												:aria-controls="'collapse' + idx">
												<span class="component-name">{{ item.name }}</span>
												<span class="component-quantity text-muted">{{
													item.quantity || ""
												}}</span>
												<span class="badge orange-badge component-calories"
													>{{ componentNutrition(item).calories }} kcal</span
												>
												<span
													class="badge bg-warning text-dark component-eaten"
													v-if="item.leftover_fraction > 0">
													{{ eatenPercent(item.leftover_fraction) }}% eaten
												</span>
											</button>
											<button
												v-if="canEditComponents"
												type="button"
												class="btn btn-sm btn-outline-danger component-delete-btn"
												@click.stop="removeComponent(idx)"
												:title="'Remove ' + item.name">
												<i class="bi bi-trash"></i>
											</button>
										</h2>
										<div
											:id="'collapse' + idx"
											class="accordion-collapse collapse"
											:aria-labelledby="'heading' + idx"
											data-bs-parent="#itemAccordion">
											<div class="accordion-body">
												<p v-if="item.description">{{ item.description }}</p>
												<div v-if="item.container_type" class="mb-2">
													<span class="badge bg-info text-dark"
														>Container: {{ item.container_type }}</span
													>
												</div>
												<ul class="list-unstyled mb-2">
													<li
														v-for="(value, key) in componentNutrition(item)"
														:key="key">
														<strong
															>{{
																formatNutritionKey(key)
															}}:</strong
														>
														{{ value }}
													</li>
												</ul>
												<div v-if="item.allergens && item.allergens.length">
													<span
														class="badge bg-danger text-light me-1"
														v-for="(allergen, aidx) in item.allergens"
														:key="aidx"
														>{{ allergen }}</span
													>
												</div>
											</div>
										</div>
									</div>
								</div>

								<h5 class="mt-2">Allergens</h5>
								<p>{{ getAllergens(meal.entry.allergens) }}</p>
							</template>

							<!-- Add more fields as needed -->

							<div
								class="text-center"
								v-if="hasToken() && !userStore.isViewingUser() && isOnline">
								<small
									class="text-danger"
									@click="deleteMe"
									style="cursor: pointer"
									>DELETE ITEM</small
								>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							@click="closeModal"
							type="button"
							class="btn btn-secondary"
							data-bs-dismiss="modal">
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
		<div
			v-if="isFullScreen"
			class="fullscreen-dialog"
			@click="isFullScreen = false">
			<img :src="getImageSource(meal.img)" class="img-fluid" />
		</div>
		<leftovers-modal
			:meal="meal"
			:show="showLeftoversModal"
			@close="showLeftoversModal = false" />
	</teleport>
</template>

<script setup>
	import { ref, computed } from "vue"
	import { startLoading, stopLoading } from "@/utils/loaderBus"
	import Swal from "sweetalert2"
	import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import Markdown from "./Markdown.vue"
	import moment from "moment-timezone"
	import RatingGauge from "./RatingGauge.vue"
	import Tags from "./Tags.vue"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import { getImageSource, getName, getDescription } from "../utils/mealLib"
	import ImageLoader from "./ImageLoader.vue"
	// const router = useRouter()
	import { useUserStore } from "@/stores/user"
	import { isOnline } from "@/utils/networkBus"
	import { showAd, upgradeAd } from "@/utils/adBus"
	import LeftoversModal from "./LeftoversModal.vue"
	import Allergy from "./Allergy.vue"
	import { bloodSugarNotif } from "@/utils/notif"
	import checkNewRestaurant from "@/utils/newRestaurant"
	import * as SubscriptionHelper from "@/utils/subscriptionHelper"
	import { Capacitor } from "@capacitor/core"

	const tokenStore = useTokenStore()
	const { hasToken } = tokenStore

	const userStore = useUserStore()

	// const modal = ref(null)
	const showPrompt = ref(false)
	const showTag = ref(false)
	const showQuickAddModal = ref(false)
	const showLeftoversModal = ref(false)
	const newPrompt = ref(null)
	const isFullScreen = ref(false)
	const quickAddDate = ref(moment().format("YYYY-MM-DDTHH:mm"))
	const showBeforeNutritionInfo = ref(false)
	const showtoggleCookingInstructions = ref(false)
	const showInsights = ref(false)
	const cookingLoading = ref(false)
	const cookingInstructions = ref("")
	const generatedInsights = ref(null)
	const selectedComponentIndexes = ref([])
	const props = defineProps(["meal", "show"])
	const emit = defineEmits(["close"])

	const newCookType = ref("")
	const newMealType = ref("")
	const newRestaurantName = ref("")
	const newDateTime = ref("")
	// Custom restaurant data
	const customRestaurantData = ref(null)

	const maxLenTrunc = 140
	const isTruncated = computed(() => {
		return getDescription(props.meal).length > maxLenTrunc
	})
	const truncatedImageDescription = computed(() => {
		const imgDesc = getDescription(props.meal)
		return imgDesc.length > maxLenTrunc
			? imgDesc.substring(0, maxLenTrunc) + "..."
			: imgDesc
	})
	const canEditComponents = computed(() => {
		return (
			hasToken() &&
			isOnline.value &&
			!userStore.isViewingUser() &&
			props.meal?.entry?.version === 2 &&
			Array.isArray(props.meal?.entry?.items)
		)
	})

	// 	function shareToX() {
	// 		//generate caption
	// 		const caption = `
	// 📸 Just logged my ${
	// 			props.meal.entry.meal_name || props.meal.entry.drink_name
	// 		} on #GrubVision!

	// ✅ ${props.meal.entry.nutritional_info.calories} cals · ${
	// 			props.meal.entry.nutritional_info.fats
	// 		} fat · ${props.meal.entry.nutritional_info.carbs} carbs · ${
	// 			props.meal.entry.nutritional_info.protein
	// 		} protein — tracked automatically from a single photo.

	// Grub Vision lets you snap, track, and level-up your meals in seconds. Ready to see what your plate says about you?
	// 👉 Try it free: https://grubvision.com
	// 		`

	// 		//encode caption
	// 		const encodedCaption = encodeURIComponent(caption.trim())

	// 		//encode image if exists
	// 		let encodedImage = null
	// 		if (props.meal.img) {
	// 			encodedImage = encodeURIComponent(
	// 				// `https://bucket.grubvision.com/${props.meal.img}`
	// 				"https://bucket.grubvision.com/bbbfe01c-fde8-40e7-96d2-b699f6c3dfa8.png"
	// 			)
	// 		}

	// 		//launch intent
	// 		const tweetUrl = `https://x.com/intent/tweet?text=${encodedCaption}&url=${encodedImage}`
	// 		window.open(tweetUrl, "_blank")
	// 	}

	function showMoreImgDesc() {
		Swal.fire({ icon: "info", html: getDescription(props.meal) })
	}

	// Voice recording state
	// const showRec = ref(
	// 	typeof navigator?.mediaDevices?.getUserMedia === "function"
	// )
	// const showRecording = ref(false)
	// const recordingStatus = ref("")
	// const sendingAudio = ref(false)
	// let mediaRecorder
	// let audioChunks = []
	// let sendData = false

	const insights = () => props.meal.rating_insights || generatedInsights.value
	const displayedInsights = () => insights() || ""

	function hideAll() {
		showLeftoversModal.value = false
		showPrompt.value = false
		showQuickAddModal.value = false
		showInsights.value = false
		newPrompt.value = ""
		selectedComponentIndexes.value = []
		// fileInput.value = null
		cookingInstructions.value = null
		showtoggleCookingInstructions.value = false
		closeTagClick()
		// cancelRecording()
	}

	function closeModal() {
		hideAll()
		generatedInsights.value = null
		emit("close")
	}

	function closeTagClick() {
		showTag.value = false
		newRestaurantName.value = ""
		newMealType.value = ""
		newCookType.value = ""
		newDateTime.value = ""
		customRestaurantData.value = null
	}

	// Handle custom restaurant data from Tags component
	function handleCustomRestaurant(data) {
		customRestaurantData.value = data
	}

	async function submitTagClick() {
		await checkNewRestaurant(newCookType.value, customRestaurantData.value)

		startLoading()
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const itemType = props.meal.entry.meal_name ? "meal" : "drink"
			const response = await fetchWithAuth(
				`/api/attr-edit/${itemType}/${props.meal.id}`,
				{
					method: "PATCH",
					headers: {
						"Content-Type": "application/json",
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
					body: JSON.stringify({
						timestamp: moment(newDateTime.value).utc().unix(),
						cookType: newCookType.value,
						mealType: newMealType.value,
						restaurantName: newRestaurantName.value,
					}),
				}
			)

			stopLoading()
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			if (!data.error) {
				await Swal.fire({
					icon: "success",
					title: `Attributes updated!`,
				})
				// lastMealUpdated.value = data.data
				EventBus.emit("meal-updated", data.data)
				closeTagClick()
				// location.reload()
			} else {
				Swal.fire({
					icon: "error",
					title: data.message ?? "Something happened. Try again later.",
				})
			}
			// }
		} catch (e) {
			stopLoading()
			console.log(e)
			Swal.fire({
				icon: "error",
				title: e.message,
			})
		}
	}

	function handleTagClick() {
		newDateTime.value = moment
			.unix(props.meal.timestamp)
			.format("YYYY-MM-DDTHH:mm")
		showTag.value = true
	}

	async function toggleInsights() {
		if (!insights()) {
			//fetch it
			if (!isOnline.value) return

			if (SubscriptionHelper.isFreeAccount()) {
				// if (Capacitor.isNativePlatform()) {
				// 	showAd.value = true
				// 	upgradeAd.value = true
				// } else {
				// 	upgradeAd.value = true
				// }
				SubscriptionHelper.showLockedModal("Insights")
				return
			}

			try {
				startLoading()
				// const itemType = props.meal.entry.meal_name ? "meal" : "drink"
				const response = await fetchWithAuth(
					`/api/report/rating/${props.meal.id}`,
					{
						headers: {
							"Content-Type": "application/json",
							// Authorization: `Bearer ${tokenStore.token}`,
						},
					}
				)
				stopLoading()
				// if (hasTokenIssue(response)) {
				// 	handleTokenIssue(response)
				// } else {
				const data = await response.json()
				if (data.error) {
					throw new Error(data.error)
				}
				hideAll()
				generatedInsights.value = data.rating_insights
				showInsights.value = true

				// }
			} catch (error) {
				stopLoading()
				console.error("Error fetching insights:", error)
				Swal.fire({
					icon: "error",
					title: error.message,
				})
			}
		} else {
			const prev = showInsights.value
			if (!prev) hideAll()
			showInsights.value = !prev
		}
	}

	async function toggleCookingInstructions() {
		const feature = "Cooking instructions"
		if (!SubscriptionHelper.isFreeAccount()) {
			showtoggleCookingInstructions.value = !showtoggleCookingInstructions.value

			if (!cookingInstructions.value) {
				cookingLoading.value = true

				//fetch it
				try {
					const response = await fetchWithAuth("/api/cooking_instructions", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							// Authorization: `Bearer ${tokenStore.token}`,
						},
						body: JSON.stringify({
							meal: props.meal.entry.meal_name ?? props.meal.entry.title,
						}),
					})
					// if (hasTokenIssue(response)) {
					// 	handleTokenIssue(response)
					// } else {

					if (
						!(await SubscriptionHelper.requestCheckSubscription(
							response,
							feature
						))
					) {
						cookingLoading.value = false
						showtoggleCookingInstructions.value = false
						return
					}

					if (!response.ok) {
						throw new Error("Failed to fetch cooking instructions")
					}
					const data = await response.json()
					cookingInstructions.value = data.instructions
					// }
				} catch (error) {
					console.error("Error fetching cooking instructions:", error)
					Swal.fire({
						icon: "error",
						title: error.message,
					})
				}

				cookingLoading.value = false
			}
		} else {
			SubscriptionHelper.showLockedModal(feature)
		}
	}

	// ---------- Leftovers (flow lives in LeftoversModal.vue) ----------
	function clamp01(value) {
		const num = Number(value)
		if (!Number.isFinite(num)) return 0
		return Math.min(Math.max(num, 0), 1)
	}

	function eatenPercent(fractionRemaining) {
		return Math.round((1 - clamp01(fractionRemaining)) * 100)
	}

	// follows the Original/Consumed toggle: components show their original
	// nutrition when the user is viewing the original totals
	function componentNutrition(item) {
		return showBeforeNutritionInfo.value && item.original_nutritional_info
			? item.original_nutritional_info
			: item.nutritional_info
	}

	function openLeftovers() {
		//plus feature
		if (SubscriptionHelper.isFreeAccount()) {
			SubscriptionHelper.showLockedModal("Leftovers")
			return
		}
		hideAll()
		showLeftoversModal.value = true
	}

	function showQuickAdd() {
		//if they have plus or higher then cool other wise feature is locked out.
		const feature = "Quick Duplicate"
		if (!SubscriptionHelper.isFreeAccount()) {
			quickAddDate.value = moment().format("YYYY-MM-DDTHH:mm")
			showQuickAddModal.value = true
		} else {
			SubscriptionHelper.showLockedModal(feature)
		}
	}

	async function handleQuickAdd() {
		startLoading()
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const itemType = props.meal.type //? "meal" : "drink"
			const response = await fetchWithAuth(
				`/api/quick-add/${itemType}/${props.meal.id}`,
				{
					method: "PATCH",
					headers: {
						"Content-Type": "application/json",
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
					body: JSON.stringify({
						timestamp: moment(quickAddDate.value).utc().unix(),
					}),
				}
			)

			stopLoading()

			const feature = "Quick Duplicate"
			if (
				!(await SubscriptionHelper.requestCheckSubscription(response, feature))
			)
				return

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			if (!data.error) {
				await Swal.fire({
					icon: "success",
					title: `${
						itemType.charAt(0).toUpperCase() + itemType.slice(1)
					} Quick Added!`,
				})

				//add notification
				//has notif enabled?
				if (userStore.user?.bloodSugarNotifications) {
					await bloodSugarNotif(
						props.meal.meal_type,
						userStore.user?.bloodSugarNotificationDelay,
						quickAddDate.value
					)
				}
				// location.reload()
				// lastMealUpdated.value = data.data
				EventBus.emit("meal-updated", data.data)
				closeModal()
			} else {
				Swal.fire({
					icon: "error",
					title:
						data.message ??
						data.error ??
						"Something happened. Try again later.",
				})
			}
			// }
		} catch (e) {
			console.log(e)
		} finally {
			stopLoading()
			showQuickAddModal.value = false
		}
	}

	// Added cancel function
	function cancelQuickAdd() {
		showQuickAddModal.value = false
		// Optionally reset quickAddDate or any other state if necessary
		quickAddDate.value = moment().format("YYYY-MM-DDTHH:mm")
	}

	async function deleteMe() {
		const results = await Swal.fire({
			icon: "question",
			title: "Are you sure you want to delete this entry?",
			showCancelButton: true,
			showConfirmButton: true,
			cancelButtonText: "No",
			confirmButtonText: "Yes",
			reverseButtons: true,
			allowOutsideClick: false,
		})
		if (results.value) {
			startLoading()
			try {
				const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
				const itemType = props.meal.type === "food" ? "meal" : "drink"
				const response = await fetchWithAuth(
					`/api/delete-item/${itemType}/${props.meal.id}`,
					{
						method: "DELETE",
						headers: {
							"User-Timezone": tz,
							// Authorization: `Bearer ${tokenStore.token}`,
						},
					}
				)

				stopLoading()
				// if (hasTokenIssue(response)) {
				// 	handleTokenIssue(response)
				// } else {
				const data = await response.json()
				// location.reload()
				// lastMealDeleted.value = props.meal
				EventBus.emit("meal-deleted", props.meal)
				closeModal()
				// }
			} catch (e) {
				console.log(e)
			} finally {
				stopLoading()
			}
		}
	}

	function getComponentSelection(indexes) {
		const items = props.meal?.entry?.items ?? []
		return [...new Set(indexes)]
			.filter((index) => Number.isInteger(index) && index >= 0 && index < items.length)
			.sort((a, b) => a - b)
	}

	async function confirmComponentRemoval(indexes) {
		const items = props.meal?.entry?.items ?? []
		const selected = getComponentSelection(indexes)
		if (!selected.length) return false

		const deletesAllComponents = selected.length === items.length
		const title =
			selected.length === 1
				? `Remove ${items[selected[0]].name}?`
				: deletesAllComponents
					? "Delete the whole food item?"
					: `Remove these ${selected.length} components?`
		const text = deletesAllComponents
			? "This will break the food item. Deleting all components will also delete the food item."
			: "The total nutritional info and allergens will be recalculated after removal."

		const results = await Swal.fire({
			icon: deletesAllComponents ? "warning" : "question",
			title,
			text,
			showCancelButton: true,
			showConfirmButton: true,
			cancelButtonText: "Cancel",
			confirmButtonText: deletesAllComponents ? "Delete food item" : "Remove",
			confirmButtonColor: "#dc3545",
			reverseButtons: true,
			allowOutsideClick: false,
		})

		return results.value ? selected : false
	}

	async function removeComponents(indexes) {
		if (!canEditComponents.value) return

		const selected = await confirmComponentRemoval(indexes)
		if (!selected) return

		startLoading()
		try {
			const itemType = props.meal.type === "food" ? "meal" : "drink"
			const response = await fetchWithAuth(
				`/api/item-components/${itemType}/${props.meal.id}`,
				{
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						componentIndexes: selected,
					}),
				}
			)

			const data = await response.json()
			if (data.error) {
				throw new Error(data.error)
			}

				if (data.deleted) {
					EventBus.emit("meal-deleted", props.meal)
					selectedComponentIndexes.value = []
					stopLoading()
					closeModal()
					return
				}

				EventBus.emit("meal-updated", data.data)
				selectedComponentIndexes.value = []
				stopLoading()
				await Swal.fire({
					icon: "success",
					title: "Components removed!",
				})
			} catch (error) {
				console.error("Error removing components:", error)
				stopLoading()
				await Swal.fire({ icon: "error", title: error.message })
			} finally {
				stopLoading()
			}
	}

	function removeComponent(index) {
		removeComponents([index])
	}

	function removeSelectedComponents() {
		removeComponents(selectedComponentIndexes.value)
	}

	function cancelPrompt() {
		showPrompt.value = false
		newPrompt.value = null
	}

	async function sendPrompt() {
		if (newPrompt.value && newPrompt.value.length > 0) {
			if (SubscriptionHelper.isFreeAccount()) {
				// if (Capacitor.isNativePlatform()) {
				// 	showAd.value = true
				// } else {
				upgradeAd.value = true
				// }
			}

			startLoading()

			try {
				// Make the POST request using fetch
				const response = await fetchWithAuth("/api/edit-item", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						// Authorization: `Bearer ${tokenStore.token}`,
					},
					body: JSON.stringify({
						id: props.meal.id,
						prompt: newPrompt.value,
						itemType: props.meal.type === "food" ? "meal" : "drink",
					}),
				})

				stopLoading()

				// if (hasTokenIssue(response)) {
				// 	handleTokenIssue(response)
				// } else {
				// Convert the response to JSON
				const responseData = await response.json()
				if (responseData.error) {
					throw new Error(responseData.error)
				}

				// if (!response.ok) {
				// 	// Handle HTTP error response
				// 	throw new Error(`HTTP error: ${response.status}`)
				// }

				await Swal.fire({ icon: "success", title: "Meal uploaded!" })
				// lastMealUpdated.value = responseData.data
				EventBus.emit("meal-updated", responseData.data)
				// location.reload()
				cancelPrompt()
				// }
			} catch (error) {
				// Handle error
				console.error("Error submitting meal:", error)
				Swal.fire({ icon: "error", title: error.message })
			} finally {
				stopLoading()
			}
		} else {
			Swal.fire({ icon: "error", title: "Text box is empty." })
		}
	}

	function showRePrompt() {
		showPrompt.value = true
	}

	function getAllergens(c) {
		// const a = c
		// 	.flatMap((cc) => cc.allergens)
		// 	.filter((item, index, arr) => arr.indexOf(item) === index)
		// console.log(a)
		// return a.length > 0 ? a.join(", ") : "None"
		return c.length > 0 ? c.join(", ") : "None"
	}

	function formatNutritionKey(key) {
		const labels = {
			calories: "Calories",
			fats: "Total Fat",
			trans_fat: "Trans Fat",
			fat_saturated: "Saturated Fat",
			fat_unsaturated: "Unsaturated Fat",
			cholesterol: "Cholesterol",
			carbs: "Carbs",
			protein: "Protein",
			fiber: "Fiber",
			sugars: "Sugars",
			sodium: "Sodium",
		}

		return (
			labels[key] ||
			String(key)
				.replace(/_/g, " ")
				.replace(/\b\w/g, (letter) => letter.toUpperCase())
		)
	}

	function getCookTypeColor(type) {
		if (type === "restaurant") {
			return "bg-danger"
		}
		return "bg-secondary"
	}

	function getMealTypeColor(type) {
		return "bg-primary"
	}

	// Voice recording functions
	// async function startRecording() {
	// 	sendData = false
	// 	try {
	// 		const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
	// 		console.log(stream)
	// 		mediaRecorder = new MediaRecorder(stream)
	// 		audioChunks = []

	// 		mediaRecorder.ondataavailable = (event) => {
	// 			audioChunks.push(event.data)
	// 		}

	// 		mediaRecorder.onstop = async () => {
	// 			if (sendData) {
	// 				sendingAudio.value = true
	// 				const audioBlob = new Blob(audioChunks, { type: "audio/wav" })
	// 				const formData = new FormData()
	// 				formData.append("audio", audioBlob)
	// 				console.log(formData)
	// 				try {
	// 					const response = await fetch("/api/whisper", {
	// 						method: "POST",
	// 						body: formData,
	// 						headers: {
	// 							Authorization: `Bearer ${tokenStore.token}`,
	// 						},
	// 					})
	// 					const result = await response.json()
	// 					if (result.error) {
	// 						throw new Error(result.error)
	// 					}
	// 					// Swal.fire({ icon: "success", title: "Recording sent!" })
	// 					newPrompt.value = result.response.text
	// 				} catch (error) {
	// 					console.error("Error sending recording:", error)
	// 					Swal.fire({ icon: "error", title: error.message })
	// 				}
	// 				sendingAudio.value = false
	// 			}
	// 			showRecording.value = false
	// 			stream
	// 				.getTracks() // get all tracks from the MediaStream
	// 				.forEach((track) => track.stop()) // stop each of them
	// 			mediaRecorder = null
	// 			recordingStatus.value = ""
	// 		}

	// 		mediaRecorder.start()
	// 		recordingStatus.value = "Recording..."
	// 		showRecording.value = true
	// 	} catch (error) {
	// 		console.error("Error starting recording:", error)
	// 		Swal.fire({ icon: "error", title: error.message })
	// 	}
	// }

	// function stopRecording() {
	// 	sendData = true
	// 	recordingStatus.value = "Sending..."
	// 	mediaRecorder.stop()
	// }

	// function cancelRecording() {
	// 	if (mediaRecorder) {
	// 		sendData = false
	// 		mediaRecorder.stop()
	// 	}
	// }

	// watch(
	// 	() => props.show,
	// 	(nv, ov) => {
	// 		console.log(nv)
	// 		if (nv) {
	// 			openModal()
	// 		}
	// 	},
	// 	{ immediate: true }
	// )
</script>

<style lang="less" scoped>
	@import "../assets/colors.less";

	//hack to make sure it is the right color
	div:first-child {
		--bs-heading-color: #ff6400;
		--bs-modal-color: #ff6400;
		--bs-card-color: #ff6400;
		--bs-card-title-color: #ff6400;
	}

	// .btn-outline-orange {
	// 	border-color: @color4;
	// 	color: @color4;
	// }

	.cover-container {
		position: relative;
		height: 200px; // Adjust max-height as needed
		// overflow: hidden;
		margin-bottom: @spacing; // Use a variable for spacing or replace with a value

		.cover-image {
			::v-deep(> .skeleton) {
				padding: 0;
			}
			::v-deep(> img) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center; // This centers the image in the container
			}
		}

		.cover-overlay {
			position: absolute;
			top: 0;
			// start: 0;
			width: 100%;
			height: 100%;
			background: rgba(
				0,
				0,
				0,
				0.5
			); // Semi-transparent overlay for text readability
			display: flex;
			align-items: center;
			justify-content: center;

			.allergy-container {
				position: absolute;
				bottom: 10px;
				left: 10px;
			}

			.rating-container {
				// background: rgba(0, 0, 0, 0.3);
				position: absolute;
				bottom: 10px;
				right: 10px;
				cursor: pointer;
			}

			.location {
				position: absolute;
				top: 35px;
				right: 20px;
				background: rgba(0, 0, 0, 0.2);
			}

			.badges {
				position: absolute;
				top: 10px;
				right: 20px;
			}

			p {
				text-align: center;
				padding: @padding; // Use a variable for padding or replace with a value
				z-index: 2;
				color: @text-color-white; // Use a variable for text color or replace with a value
				height: 80px;
				// display: -webkit-box;
				// -webkit-line-clamp: 3;
				// -webkit-box-orient: vertical;
				// overflow: hidden;
			}
		}
	}

	// Variables (if not defined, replace with actual values)
	@spacing: 1rem;
	@padding: 1rem;
	@text-color-white: #fff;

	.nutrition-label {
		font-family: Arial, sans-serif;
		background: @label-background-color;
		padding: @label-padding;
		border: @label-border-width solid @label-border-color;
		border-radius: @label-border-radius;
		margin-bottom: @label-margin-bottom;

		h3 {
			font-size: @label-header-font-size;
			border-bottom: @label-header-border-width solid @label-border-color;
			padding-bottom: @label-header-padding-bottom;
			margin-bottom: @label-header-margin-bottom;
		}

		ul {
			list-style-type: none;
			padding: 0;
			margin: 0;

			li {
				display: flex;
				justify-content: space-between;
				font-size: @label-item-font-size;
				border-bottom: 1px solid @label-item-border-color;
				padding: @label-item-padding;

				&:last-child {
					border-bottom: none;
				}
			}
		}
	}

	// Variables (if not defined, replace with actual values)
	@label-background-color: #f9f9f9;
	@label-padding: 10px;
	@label-border-width: 1px;
	@label-border-color: #eaeaea;
	@label-border-radius: 5px;
	@label-margin-bottom: 20px;
	@label-header-font-size: 16px;
	@label-header-border-width: 2px;
	@label-header-padding-bottom: 5px;
	@label-header-margin-bottom: 10px;
	@label-item-font-size: 14px;
	@label-item-border-color: #ddd;
	@label-item-padding: 5px 0;

	.modal {
		display: none; // Hidden by default
		position: fixed;
		z-index: 1050;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		outline: 0;
		background-color: rgba(0, 0, 0, 0.5); // Semi-transparent backdrop
		&.show {
			display: block; // Show the modal when .show is added
			overflow-x: hidden;
			overflow-y: auto;
		}
		.modal-dialog {
			position: relative;
			width: auto;
			margin: 1rem;
			pointer-events: none;
			@media (min-width: 576px) {
				max-width: 500px; // Adjust to your preference
				margin: 1.75rem auto;
			}
			.modal-content {
				position: relative;
				display: flex;
				flex-direction: column;
				width: 100%;
				pointer-events: auto;
				background-color: #fff; // Modal content background color
				border: 1px solid #dee2e6; // Modal content border
				border-radius: 0.3rem; // Modal content border radius
				outline: 0;
				.modal-header {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 1rem; // Modal inner padding
					border-bottom: 1px solid #dee2e6; // Modal header border color
					border-top-left-radius: 0.3rem; // Modal content border radius
					border-top-right-radius: 0.3rem; // Modal content border radius
					.modal-title {
						margin-bottom: 0;
						line-height: 1.5; // Modal title line height
					}
					.btn-close {
						padding: 0.5rem; // Modal header padding
						margin: -0.5rem -0.5rem -0.5rem auto;
					}
				}
				.modal-body {
					position: relative;
					flex: 1 1 auto;
					padding: 1rem; // Modal inner padding
				}
				.modal-footer {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					padding: 1rem; // Modal inner padding
					border-top: 1px solid #dee2e6; // Modal footer border color
					border-bottom-right-radius: 0.3rem; // Modal content border radius
					border-bottom-left-radius: 0.3rem; // Modal content border radius
				}
			}
		}
	}

	.fullscreen-button {
		position: absolute;
		top: 10px; /* Adjust as needed */
		left: 10px; /* Adjust as needed */
		z-index: 10;
		/* Style the button as needed */
	}

	.fullscreen-dialog {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.8); /* Dim background */
		z-index: 1050; /* Ensure it's above other content */
	}

	.fullscreen-dialog img {
		max-width: 90%;
		max-height: 90%;
		object-fit: contain; /* Ensure the image fits within the viewport */
	}

	/* ───── PHONE‑ONLY LAYOUT ( ≤ 575 px ) ───────────────────────── */
	@media (max-width: 575.98px) {
		/* 1️⃣  Modal itself – edge‑to‑edge, but keep default header/footer */
		// .modal-dialog {
		// 	margin: 0;
		// 	max-width: 100%;
		// }

		.showMore {
			font-size: 12px;
			padding-top: 5px;
		}

		.cover-overlay p {
			// font-size: 0.78rem;
			// line-height: 1.1;
			height: 50px !important;
			font-size: 12px;
			line-height: 16px;
			// margin-top: px;
		}
		.rating-container {
			transform: scale(0.8);
			right: 6px;
			bottom: 6px;
		}
		.badges span,
		.location {
			font-size: 12px;
			// font-size: 0.65rem;
			// padding: 0.1rem 0.35rem;
		}
	}

	.orange-accordion .accordion-item {
		border: 1.5px solid #ff6400;
		border-radius: 8px;
		margin-bottom: 8px;
		overflow: hidden;
	}
	.orange-accordion {
		container-type: inline-size;
	}
	.orange-accordion .accordion-header {
		background: #fff7f2;
	}
	.component-accordion-header {
		display: grid;
		grid-template-columns: 54px minmax(0, 1fr) 38px;
		align-items: stretch;
		min-height: 66px;
	}
	.component-select {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		margin: 0;
		border-right: 1px solid rgba(255, 100, 0, 0.18);
	}
	.component-select .form-check-input {
		margin: 0;
		width: 1.3rem;
		height: 1.3rem;
		cursor: pointer;
	}
	.component-delete-btn {
		border: none;
		border-left: 1px solid rgba(255, 100, 0, 0.18);
		border-radius: 0;
		padding: 0;
		color: #dc3545;
	}
	.orange-accordion .accordion-button {
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(108px, auto) 82px 20px;
		column-gap: 10px;
		align-items: center;
		color: #ff6400;
		background: #fff7f2;
		font-weight: 600;
		border: none;
		box-shadow: none;
		padding: 0.75rem 0.55rem 0.75rem 1.25rem;
		min-width: 0;
	}
	.component-name {
		grid-column: 1;
	}
	.component-quantity {
		grid-column: 2;
	}
	.component-calories {
		grid-column: 3;
	}
	.orange-accordion .accordion-button::after {
		grid-column: 4;
		margin-left: 0;
		justify-self: center;
		width: 1rem;
		height: 1rem;
		background-size: 1rem;
	}
	.component-name {
		min-width: 0;
		overflow-wrap: anywhere;
		line-height: 1.15;
	}
	.component-quantity {
		color: #606060 !important;
		line-height: 1.15;
		text-align: right;
		overflow-wrap: normal;
		word-break: normal;
	}
	.component-calories {
		justify-self: start;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 82px;
		min-height: 26px;
		white-space: nowrap;
	}
	.orange-accordion .accordion-button:not(.collapsed) {
		color: #fff;
		background: #ff6400;
	}
	.orange-accordion .accordion-button:not(.collapsed) .component-quantity {
		color: rgba(255, 255, 255, 0.86) !important;
	}
	.orange-accordion .accordion-button:focus {
		box-shadow: 0 0 0 0.2rem rgba(255, 100, 0, 0.15);
	}
	.orange-badge {
		background: #ff6400 !important;
		color: #fff !important;
		font-weight: 600;
		font-size: 0.95em;
	}
	.component-eaten {
		grid-column: 1 / 4;
		grid-row: 2;
		justify-self: start;
		margin-top: 0.25rem;
	}

	@container (max-width: 520px) {
		.component-accordion-header {
			grid-template-columns: 44px minmax(0, 1fr) 32px;
			min-height: 76px;
		}
		.component-select .form-check-input {
			width: 1.15rem;
			height: 1.15rem;
		}
		.orange-accordion .accordion-button {
			grid-template-columns: minmax(0, 1fr) auto 18px;
			grid-template-rows: auto auto auto;
			column-gap: 8px;
			row-gap: 0.3rem;
			padding: 0.75rem 0.4rem 0.75rem 0.85rem;
			font-size: 0.92rem;
		}
		.orange-accordion .accordion-button::after {
			grid-column: 3;
			grid-row: 1 / 4;
		}
		.component-name {
			grid-column: 1 / 3;
			grid-row: 1;
			overflow-wrap: normal;
			word-break: normal;
		}
		.component-quantity {
			grid-column: 1 / 3;
			grid-row: 2;
			text-align: left;
			white-space: normal;
		}
		.orange-badge {
			font-size: 0.85em;
		}
		.component-calories {
			grid-column: 1 / 3;
			grid-row: 3;
			width: 70px;
			justify-self: start;
		}
		.component-eaten {
			grid-column: 1 / 3;
			grid-row: 4;
			justify-self: start;
		}
		.component-delete-btn {
			font-size: 0.85rem;
		}
	}
</style>
